import React from 'react';

const Input = React.forwardRef((props, ref) => {
  return (
    <div className={props.className ?props.className :'flex flex-col gap-[6px]'}>
      {props.label !== "" ? <label htmlFor={props.input.id} className={props.labelClass}>{props.label}  {props.isManditory && <span> *</span>}</label>: ""}
      <input ref={ref} {...props.input} />
    </div>
  );
});

export default Input;
